import { CurrentCardService } from '@addins/core/core';
import { CollapsibleItemsService } from '@addins/core/singlecallcard';
import { Injectable } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { Subscription } from 'rxjs';
import { DepartureTicketInfoCollapsibleItem } from '../../../schema/departure-ticket-info-collapsible-item';
import { DepartureTicketInfoService } from '../../departure-ticket-info/departure-ticket-info.service';

@AddinExecute({
  name: 'DepartureTicketInfoCollapsibleSetup'
})
@Injectable({
  providedIn: 'root'
})
export class DepartureTicketInfoCollapsibleService extends Execute {
  private departureTicketInfoCollapsibleItem = new DepartureTicketInfoCollapsibleItem();
  private requestSub: Subscription = null;

  constructor(
    private collapsibleItems: CollapsibleItemsService,
    private currentCardService: CurrentCardService,
    private departureTicketInfoService: DepartureTicketInfoService
  ) {
    super();
  }

  execute() {
    this.currentCardService.$change.subscribe(callcard => this.onCardChanged(callcard));
    this.collapsibleItems.register(this.departureTicketInfoCollapsibleItem);
  }

  private onCardChanged(callcard: CallCard) {
    this.departureTicketInfoCollapsibleItem.setVisible(false);

    if (callcard) {
      this.requestSub = this.departureTicketInfoService
        .getDepartureTicketInfo(callcard.ObjGuid)
        .subscribe(departureTicketInfo => this.departureTicketInfoCollapsibleItem.setVisible(!!departureTicketInfo));
    } else {
      this.requestSub?.unsubscribe();
      this.requestSub = null;
    }
  }
}
